/**
 * Subscribes the signup band's theme form straight to a Klaviyo list.
 *
 * sections/new-to-altenew-signup.liquid renders a hidden [data-klaviyo-list]
 * next to the theme's newsletter form when the band has a Klaviyo list ID. On
 * submit this sends the email to Klaviyo's public subscribe endpoint and swaps
 * the form for the thank-you note, so the page never reloads. The list's own
 * opt-in setting decides whether Klaviyo sends a confirmation email first.
 *
 * The Shopify customer form stays underneath as the fallback. If Klaviyo
 * refuses or cannot be reached, the normal submit goes through, so the email
 * is saved as a customer rather than lost.
 *
 * Listens on document in the capture phase so it runs before Shopify's CAPTCHA
 * handler, which would otherwise take the submit first. The fallback resubmits
 * with requestSubmit(), which fires the submit event again, so the CAPTCHA
 * still runs on that path.
 */
(function () {
  if (window.__ntaKlaviyoList) return;
  window.__ntaKlaviyoList = true;

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=';
  var REVISION = '2024-10-15';
  var TIMEOUT_MS = 8000;

  function configFor(form) {
    var band = form.closest('.nta-signup__form');
    return band && band.querySelector('[data-klaviyo-list]');
  }

  function subscribe(config, email) {
    var controller = window.AbortController ? new AbortController() : null;
    var timer = controller && setTimeout(function () { controller.abort(); }, TIMEOUT_MS);

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: config.dataset.klaviyoSource || '',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          list: { data: { type: 'list', id: config.dataset.klaviyoList } }
        }
      }
    };

    return fetch(ENDPOINT + encodeURIComponent(config.dataset.klaviyoAccount), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body),
      signal: controller ? controller.signal : undefined
    })
      .then(function (response) { return response.ok; })
      .catch(function () { return false; })
      .then(function (ok) {
        if (timer) clearTimeout(timer);
        return ok;
      });
  }

  function thank(form, message) {
    var note = document.createElement('div');
    note.className = 'note note--success';
    note.setAttribute('role', 'status');
    note.setAttribute('tabindex', '-1');
    note.textContent = message;
    form.replaceChildren(note);
    note.focus();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('newsletter-form')) return;
    if (form.dataset.klaviyoFallback) return;

    var config = configFor(form);
    if (!config) return;

    var input = form.querySelector('input[type="email"]');
    var email = input && input.value.trim();
    if (!email) return;

    event.preventDefault();
    event.stopPropagation();

    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    form.setAttribute('aria-busy', 'true');

    subscribe(config, email).then(function (ok) {
      form.removeAttribute('aria-busy');
      if (ok) {
        thank(form, config.dataset.success);
        return;
      }
      if (button) button.disabled = false;
      form.dataset.klaviyoFallback = 'true';
      if (form.requestSubmit) form.requestSubmit(button || undefined);
      else form.submit();
    });
  }, true);
})();
